import { Modal, type ModalProps } from '../modal/modal.tsx'
import { LoadingCenter } from './loading-center.tsx'

const LoadingModal = ({
  ...props
}: Omit<ModalProps, 'children' | 'onClose'>) => (
  <Modal {...props} onClose={() => null} overlayClassName="backdrop-blur-none">
    <LoadingCenter />
  </Modal>
)

export { LoadingModal }
